import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Spacer = styled.div<{height?: number; width?: number}>`
  height: ${(s) => (s.height ?? 0) * 8}px;
  width: ${(s) => (s.width ?? 0) * 8}px;
`;

export const Image = styled.img`
  border-radius: 8px;
`;
